import { currentDevice } from '../../core/utils/currentDevice'
import Modal from '../../shared/modal/modal'
import { createBottomSheet } from '../bottom_sheet/bottom_sheet'

const MODAL_SELECTOR = 'external-url-modal'
const modalElement = document.getElementById(MODAL_SELECTOR)

function initializeModalButtons(dialogInstance) {
  const acceptButton = modalElement.querySelector('.js-external-url-accept-button')
  acceptButton.addEventListener(
    'click',
    () => {
      dialogInstance.close()
      window.open(modalElement.dataset.externalUrl, '_blank')
    },
    { once: true }
  )
  const rejectButton = modalElement.querySelector('.js-external-url-reject-button')

  rejectButton.addEventListener(
    'click',
    () => {
      dialogInstance.close()
    },
    { once: true }
  )
}

function showExternalUrlModal() {
  Modal.show(MODAL_SELECTOR, {
    onShow: () => {
      ScrollLock.on()
    },
    onClose: () => {
      ScrollLock.off()
    },
    awaitCloseAnimation: true,
  })
}

function init() {
  const externalUrlModal = document.querySelector(`#${MODAL_SELECTOR}`)

  if (!externalUrlModal) return

  let externalUrlBottomSheet

  if (!currentDevice.isMobile) {
    initializeModalButtons(Modal)
  }

  const externalUrlLinkArray = document.querySelectorAll('a[data-external-url="true"]')
  externalUrlLinkArray.forEach(externalUrlLink => {
    externalUrlLink.addEventListener('click', e => {
      e.preventDefault()
      const url = externalUrlLink.getAttribute('href')
      modalElement.dataset.externalUrl = url
      if (currentDevice.isMobile) {
        // --------------------------------------------------
        // MOBILE BOTTOM SHEET
        // --------------------------------------------------
        if (!externalUrlBottomSheet) {
          externalUrlBottomSheet = createBottomSheet({
            sheetId: MODAL_SELECTOR,
          })
          initializeModalButtons(externalUrlBottomSheet)
        }
        externalUrlBottomSheet.show()
      } else {
        showExternalUrlModal()
      }
    })
  })
}

init()
